import type { Color } from '../../../style/types/theme';
import type { ColorStyles } from '../BaseButton/types';
import { Variant } from './constants';

type Colors = Record<Variant, ColorStyles>;

export const getPrimaryColors = (themeColor: Color): Colors => {
  return {
    [Variant.ACTION]: {
      default: themeColor.background.reversed.default(),
      hover: themeColor.background.reversed.hover(),
      disabled: themeColor.background.reversed.disabled(),
    },
    [Variant.CTA]: {
      default: themeColor.background.accent.default(),
      hover: themeColor.background.accent.hover(),
      disabled: themeColor.background.accent.disabled(),
    },
    [Variant.DANGER]: {
      default: themeColor.background.danger.default(),
      hover: themeColor.background.danger.hover(),
      disabled: themeColor.background.danger.disabled(),
    },
    [Variant.DEFAULT]: {
      default: themeColor.background.secondary.default(),
      hover: themeColor.background.secondary.hover(),
      disabled: themeColor.background.secondary.disabled(),
    },
    [Variant.PLAIN]: {
      default: 'transparent',
      hover: themeColor.background.secondary.hover(),
      disabled: 'transparent',
    },
    [Variant.STROKE]: {
      default: themeColor.border.primary.default(),
      hover: themeColor.border.primary.hover(),
      disabled: themeColor.border.primary.disabled(),
    },
  };
};

export const getSecondaryColors = (themeColor: Color): Colors => {
  return {
    [Variant.ACTION]: {
      default: themeColor.content.reversed.default(),
      disabled: themeColor.content.primary.disabled(),
    },
    [Variant.CTA]: {
      default: themeColor.content.reversed.default(),
      disabled: themeColor.content.reversed.disabled(),
    },
    [Variant.DANGER]: {
      default: themeColor.content.reversed.default(),
      disabled: themeColor.content.reversed.disabled(),
    },
    [Variant.DEFAULT]: {
      default: themeColor.content.primary.default(),
      disabled: themeColor.content.primary.disabled(),
    },
    [Variant.PLAIN]: {
      default: themeColor.content.primary.default(),
      disabled: themeColor.content.primary.disabled(),
    },
    [Variant.STROKE]: {
      default: themeColor.content.primary.default(),
      disabled: themeColor.content.primary.disabled(),
    },
  };
};

export const getVariantColors = (variant: Variant, colors: Colors): ColorStyles => {
  return colors[variant] || colors[Variant.ACTION];
};
